<template>
    <div class="Table1">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="datetime" label="时间" align='center'></el-table-column>
            <el-table-column prop="payusers" label="付费用户" align='center'></el-table-column>
            <el-table-column prop="finalpaymoneysum" label="付费金额(元)" align='center'></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'Table1',
    props: ['saleTableData'],
    data() {
        return {
            tableData: []
        }
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {
        saleTableData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.tableData = this.saleTableData
            })
        }
    },
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.Table1 {}
</style>
